import { Component, OnInit } from '@angular/core';
import { APP_CONFIG, AppConfig } from '../../../shared-service/app.config';
import { BaseService } from './../../../shared-service/base.service';
import { OverviewService } from '../overview.service';


@Component({
  selector: 'profilewidget',
  templateUrl: './profilewidget.component.html',
  styleUrls: ['./profilewidget.component.css']
})
export class ProfilewidgetComponent implements OnInit {
  UserWidgetData: any = {};

  constructor(public bs: BaseService,  private overviewService: OverviewService) { }

  ngOnInit() {
    const params: Object = {};
    // api call for User details with other data
    this.overviewService.getOverViewUserProfileData(params, '****').then((userData:any) => {
      if (Object.keys(userData).length > 0) {
        this.UserWidgetData = userData;
      }
    }, (userData) => {
      this.bs.log('error', 'Error in getting list');
    });
  }

}
